<template>
  <div class="dialog-container">
    <import-client-data @success="onSuccessfulImport"></import-client-data>
    <el-row :gutter="18" class="dialog-footer">
      <el-col :span="24" class="align-right">
        <el-button @click="closeDialog">Close</el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import ImportClientData from '@/components/form-item/ImportClientData.vue';

export default {
  methods: {
    onSuccessfulImport(client) {
      this.$emit('success', client);
    },
    closeDialog() {
      this.$emit('close');
    },
  },
  components: {
    ImportClientData,
  },
};

</script>
